import { datadogRum } from '@datadog/browser-rum';

import { DATADOG_CONFIG } from '../environment/datadog/config';

export const initialiseDatadogRum = (): void => {
  try {
    datadogRum.init(DATADOG_CONFIG);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to initialise Datadog RUM:', error);
  }
};
